/* eslint-disable @typescript-eslint/no-explicit-any */
// This file contains validators that need to accept any types in order to make sure they've been decoded correctly.

// isValidJWTHeader checks if the JWT header is valid
import { JWTHeader, JWTPayload } from './types.ts'

export const isValidJWTHeader = (header: any): header is JWTHeader => {
  return (
    typeof header === 'object' &&
    header !== null &&
    typeof header.alg === 'string' &&
    typeof header.typ === 'string'
  )
}

// isValidJWTPayload checks if the JWT payload is valid
export const isValidJWTPayload = (payload: any): payload is JWTPayload => {
  return (
    typeof payload === 'object' &&
    payload !== null &&
    Array.isArray(payload.per_v1) &&
    payload.per_v1.every((item: any) => typeof item === 'string') &&
    Array.isArray(payload.rsc_v1) &&
    payload.rsc_v1.every(
      (resource: any) =>
        typeof resource === 'object' &&
        resource !== null &&
        typeof resource.k === 'string' &&
        typeof resource.v === 'string',
    ) &&
    typeof payload.sub === 'string' &&
    typeof payload.iss === 'string' &&
    Array.isArray(payload.aud) &&
    payload.aud.every((audience: any) => typeof audience === 'string') &&
    typeof payload.exp === 'number' &&
    typeof payload.iat === 'number'
  )
}
